export default __webpack_public_path__ + "db105988d91fd8fbd43d57aa1b58c11a.png";